import gql from 'graphql-tag'

const mutation = gql`
  mutation followMember($targetMemberId: String!) {
    followMember(targetMemberId: $targetMemberId) {
      publicMember {
        id
        followingCount
        followersCount
        isFollowedByMe
      }
      query {
        currentUser {
          id
          member {
            id
            followingCount
            followersCount
          }
          publicMember {
            id
            followingCount
            followersCount
          }
        }
      }
      errors {
        key
        message
      }
    }
  }
`

export default mutation
